/**
 * useEligibleSourceBriefs — Panel A data source (§5.6.1).
 *
 * Returns one row per source brief on the project, joined with the
 * existing off-page brief (if any). The API decides `can_generate` +
 * `disabled_reason` so the UI can render "Generate" / "Open" / disabled
 * button without extra logic on our side.
 */
import { useQuery } from '@tanstack/react-query';
import type { EligibleSourceBriefsResponse } from '@seo/types';
import { apiGet } from '@/lib/api';

export function useEligibleSourceBriefs(projectId: string | undefined) {
  return useQuery({
    queryKey: ['off-page-briefs', 'eligible-source-briefs', projectId],
    queryFn: () => {
      const params = new URLSearchParams();
      if (projectId) params.set('project_id', projectId);
      return apiGet<EligibleSourceBriefsResponse>(
        `/v1/off-page-briefs/eligible-source-briefs?${params.toString()}`,
      );
    },
    enabled: !!projectId,
    placeholderData: (prev) => prev,
  });
}
